export default function getRandomNumber(min: number, max: number, seed: string = "") {
  if (seed === "") {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  } else {
    const hashCode = (s: string) => {
      let hash = 0;
      if (s.length === 0) return hash;
      for (let i = 0; i < s.length; i++) {
        const char = s.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
      }
      return hash;
    };

    const seededRandom = (max: number, min: number, seed: string) => {
      let seedValue = hashCode(seed);

      max = max || 1;
      min = min || 0;

      seedValue = (seedValue * 9301 + 49297) % 233280;
      const rnd = seedValue / 233280;

      return Math.floor(min + rnd * (max - min));
    };

    return seededRandom(max, min, seed);
  }
}